interface PricingCardPriceProps {
  price: number
  recurrence: string
}

export default function PricingCardPrice({ price, recurrence }: PricingCardPriceProps) {
  return (
    <div style={{ marginBottom: '14px', marginTop: '14px', textAlign: 'center' }} className="plan_price">
      <div style={{ display: 'flex', marginBottom: '12px', justifyContent: 'center' }}>
        <p
          style={{
            color: 'var(--Text-Emphasis, #FFF)',
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: 'var(--font-inter)',
            fontSize: '36px',
            fontStyle: 'normal',
            fontWeight: '300',
            lineHeight: '110%',
            letterSpacing: '-1.4px',
            marginRight: '12px',
          }}
        >
          $
        </p>
        <p
          style={{
            color: 'var(--Text-Emphasis, #FFF)',
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: 'var(--font-inter)',
            fontSize: '88px',
            fontStyle: 'normal',
            fontWeight: '300',
            lineHeight: '110%',
            letterSpacing: '-1.4px',
          }}
        >
          {price}
        </p>
      </div>
      <p
        style={{
          color: 'var(--Text-Emphasis, #FFF)',
          fontFeatureSettings: "'clig' off, 'liga' off",
          fontFamily: 'Migra',
          fontSize: '50px',
          fontStyle: 'normal',
          fontWeight: '300',
          lineHeight: '110%',
          letterSpacing: '-1.4px',
          background: 'linear-gradient(to right, #eee, #333)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        {recurrence}
      </p>
    </div>
  )
}
